import type { PermissionGroupsType } from 'containers/Ticketing/Boards/Admin/Permissions/types';

/**
 * Mirror Copy of permission enum in BE - Validator - TicketingBoardMembershipService.ts
 * maintain this copy for permission usage consistency
 */
export enum TicketingBoardPermissionEnum {
  // has "Ticket Admin Permission" but not in a board group/member
  ONLY_TICKET_ADMIN_PERMISSIONS = 'onlyTicketAdminPermissions',

  // BOARD
  CREATE_BOARD = 'board:create',
  READ_BOARD = 'board:read',
  UPDATE_BOARD = 'board:update',
  DELETE_BOARD = 'board:delete',

  // TICKET
  CREATE_TICKET = 'ticket:create',
  READ_TICKET = 'ticket:read',
  UPDATE_TICKET = 'ticket:update',
  DELETE_TICKET = 'ticket:delete',

  // TICKET MESSAGES
  CREATE_TICKET_MESSAGES = 'ticket:message:create',
  READ_TICKET_MESSAGES = 'ticket:messages:read',
  DELETE_TICKET_MESSAGES = 'ticket:message:delete',

  // TICKET ATTACHMENTS
  READ_TICKET_ATTACHMENTS = 'ticket:attachments:read',
  UPDATE_TICKET_ATTACHMENT = 'ticket:attachment:update',

  // BOARD VIEWS
  CREATE_PERSONAL_BOARD_VIEW = 'board:personal-view:create',
  READ_PERSONAL_BOARD_VIEW = 'board:personal-view:read',
  UPDATE_PERSONAL_BOARD_VIEW = 'board:personal-view:update',
  DELETE_PERSONAL_BOARD_VIEW = 'board:personal-view:delete',
  CREATE_SHARED_BOARD_VIEW = 'board:shared-view:create',
  READ_SHARED_BOARD_VIEW = 'board:shared-view:read',
  UPDATE_SHARED_BOARD_VIEW = 'board:shared-view:update',
  DELETE_SHARED_BOARD_VIEW = 'board:shared-view:delete',

  // BOARD MEMBERSHIPS
  CREATE_BOARD_MEMBERSHIP = 'board:membership:create',
  READ_BOARD_MEMBERSHIP = 'board:membership:read',
  UPDATE_BOARD_MEMBERSHIP = 'board:membership:edit',
  DELETE_BOARD_MEMBERSHIP = 'board:membership:delete',

  // BOARD INTEGRATIONS
  CREATE_BOARD_INTEGRATION = 'board:integration:create',
  READ_BOARD_INTEGRATION = 'board:integration:read',
  UPDATE_BOARD_INTEGRATION = 'board:integration:edit',
  DELETE_BOARD_INTEGRATION = 'board:integration:delete',

  // TASKS
  CREATE_TASK = 'task:create',
  READ_TASK = 'task:read',
  UPDATE_TASK = 'task:update',
  DELETE_TASK = 'task:delete',
  TOGGLE_TASK_STATUS = 'task:toggle-status',

  // CALENDAR EVENTS
  CREATE_CALENDAR_EVENT = 'calendar-event:create',
  READ_CALENDAR_EVENT = 'calendar-event:read',
  UPDATE_CALENDAR_EVENT = 'calendar-event:update',
  DELETE_CALENDAR_EVENT = 'calendar-event:delete',
}

export enum PermissionHierachy {
  SYSTEM_PERMISSION = 'system_permission',
  APP_MEMBER_PERMISSION = 'app_member_permission',
  APP_GROUP_PERMISSION = 'app_group_permission',
  PARTICIPANT_PERMISSION = 'participant_permission',
  TICKETING_AGENT_PERMISSION = 'ticketing_agent_permission',
  TICKETING_ADMIN_PERMISSION = 'ticketing_admin_permission',
  REQUESTER_PERMISSION = 'requester_permission',
}

export interface Membership {
  hierarchy: PermissionHierachy;
  permission: TicketingBoardPermissionEnum[];
  groupType: PermissionGroupsType | null;
}

type PermissionKey = keyof typeof TicketingBoardPermissionEnum;
type MembershipKey = keyof typeof PermissionHierachy;

export const hasPermission = (
  key: PermissionKey,
  permissions: TicketingBoardPermissionEnum[]
) => permissions.includes(TicketingBoardPermissionEnum[key]);
